import Select from './Select';

export default Select;



// WEBPACK FOOTER //
// ./src/components/Select/index.jsx